import { createFileRoute } from "@tanstack/react-router";
import { SubscriptionSuccess } from "../../../features/subscriptions/routes/success";

const Route = createFileRoute("/_authorized/subscription_/success/")({
  component: () => <SubscriptionSuccess />,
});

export { Route };
